import React, { useState, useEffect } from "react";
import Select from "live/components/forms/ui/select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { listUsersApi } from "../../../api/userApi";

const UsersBox = ({
  company,
  addUser,
  removeUser,
  itemUrl,
  userGroup,
}) => {
  const [options, setOptions] = useState([]);

  let showSelect = true;
  

  useEffect(() => {
    listUsersApi(company.id)
    .then((response) => {
        let myOptions = response.data.map((user) => {
          //All users
          return { id: user.id, name: user.name };
        });

        const removeItemFromMyOptions = (id) => {
          myOptions = myOptions.filter((option) => {
            return option.id !== id;
          });
        };

        userGroup.users.map((user) => {
          removeItemFromMyOptions(user.id);
        });

        setOptions(myOptions);
      
    });
  
  }, [userGroup.id]);


  const getItem = (id) => {
    let index;
    const item = options.find((d, i) => {
      if (d["id"] === id) {
        index = i;
        return true;
      }
    });

    return item ? item : false;
  };

  const addItem = (id) => {
    const item = getItem(id);

    if (item) {
      addUser(item);
      removeItemFromOptions(id);
    }
  };

  const removeItem = (itemToRemove) => {
    removeUser(itemToRemove);
    setOptions([{ id: itemToRemove.id, name: itemToRemove.name }, ...options]);
  };

  const removeItemFromOptions = (id) => {
    setOptions(
      options.filter((option) => {
        return option.id !== id;
      })
    );
  };

  return (
    <div className="select-list">
      <Select
        label="Add users to this user group:"
        // placeholder={placeholder}
        options={options.map((user) => {
          return { value: user.id, label: user.name };
        })}
        // creatable={creatable}
        onChange={(value, option) => addItem(value)}
        className="Select-small"
        clearable={false}
        searchable={true}
      />
      <div className="list-area">
        <ul>
          {userGroup.users.map((d) => (
            <li key={d["id"]}>
              {d["name"]}

              {showSelect ? (
                <span>
                  {itemUrl ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="exclude">{"View tooltip"}</Tooltip>}
                    >
                      <a
                        href={`${itemUrl}/${d["name"]}`}
                        target="_blank"
                        className="fa fa-external-link"
                      />
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}

                  {d["defaultGroup"] ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">
                          {
                            "This user group has access to all users by definition"
                          }
                        </Tooltip>
                      }
                    >
                      <i className="fa fa-info-circle" />
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">{"Remove tooltip"}</Tooltip>
                      }
                    >
                      <button
                        className="remove-item warn"
                        onClick={() => removeItem(d)}
                      />
                    </OverlayTrigger>
                  )}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UsersBox;
